<div class="logo-container" [ngSwitch]="logoDisplayService.type">
    <img *ngSwitchCase="'branding'" src="./branding.svg"/>
    <img *ngSwitchCase="'whiteLabel'" [src]="logoDisplayService.whiteLabelLogoUrl | safe : 'url'"/>
    <img *ngSwitchCase="'login'" [src]="logoDisplayService.systemLogoUrl | safe : 'url'"/>
    <img *ngSwitchCase="'tenant'" [src]="logoDisplayService.tenantLogoUrl"/>
    <img *ngSwitchCase="'internal'" [src]="logoDisplayService.systemLogoUrl | safe : 'url'"/>
</div>
